/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：155
 */

module.exports = {
  editListDialog: "StorageDialog_editListDialog__2UZiB",
  summary: "StorageDialog_summary__2ny0-",
  count: "StorageDialog_count__2ywfL",
  input: "StorageDialog_input__17dbD",
  listHeader: "StorageDialog_listHeader__27wjQ",
  list: "StorageDialog_list__2z5Bj",
  column1: "StorageDialog_column1__2MHAr",
  column2: "StorageDialog_column2__Kr7Te",
  addBox: "StorageDialog_addBox__32pqn",
  column3: "StorageDialog_column3__1YADO",
  dataList: "StorageDialog_dataList__1oUfn",
  listItem: "StorageDialog_listItem__2bpAu",
  inputClose: "StorageDialog_inputClose__2zeWg",
  listInput: "StorageDialog_listInput__3qGqK",
  error: "StorageDialog_error__PfgWj",
  inputLabel: "StorageDialog_inputLabel__3btpq",
  emptyContent: "StorageDialog_emptyContent__3HMa-",
  label: "StorageDialog_label__15DIT",
  addRow: "StorageDialog_addRow__2MRMg",
  shadow: "StorageDialog_shadow__3A2fR",
  addButton: "StorageDialog_addButton__371YD",
  dialogTitle: "StorageDialog_dialogTitle__2kil3",
  defaultData: "StorageDialog_defaultData__3i1DK",
  footer: "StorageDialog_footer__2DZk_",
  save: "StorageDialog_save__1AnHS",
  disabled: "StorageDialog_disabled__2qFxH",
  typeFlag: "StorageDialog_typeFlag__1YPsf",
  surpriseSign: "StorageDialog_surpriseSign__OXeUW",
  typeSelectionList: "StorageDialog_typeSelectionList__2xtF7",
  active: "StorageDialog_active__39vKq",
  textAlignRight: "StorageDialog_textAlignRight__1bCxI",
  menuWrapper: "StorageDialog_menuWrapper__1_t7b",
  rowMenuWrapper: "StorageDialog_rowMenuWrapper__LA-mf",
  menuItem: "StorageDialog_menuItem__2iiBM",
  borderTop: "StorageDialog_borderTop__1o2He",
  borderBottom: "StorageDialog_borderBottom__3GnUg",
  addColumnMenuWrapper: "StorageDialog_addColumnMenuWrapper__2zLDO",
  resourceMenuItem: "StorageDialog_resourceMenuItem__GYSQo",
  resourceMenuIcon: "StorageDialog_resourceMenuIcon__Kd6C_",
  deleteOption: "StorageDialog_deleteOption__2aNM_"
}
